/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Uniqueworkplace_Label1Inputs */

const ja_careers_uniqueworkplace_label1 = /** @type {(inputs: Careers_Uniqueworkplace_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UNIQUE WORKPLACE`)
};

const en_careers_uniqueworkplace_label1 = /** @type {(inputs: Careers_Uniqueworkplace_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UNIQUE WORKPLACE`)
};

/**
* | output |
* | --- |
* | "UNIQUE WORKPLACE" |
*
* @param {Careers_Uniqueworkplace_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_uniqueworkplace_label1 = /** @type {((inputs?: Careers_Uniqueworkplace_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Uniqueworkplace_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_uniqueworkplace_label1(inputs)
	return en_careers_uniqueworkplace_label1(inputs)
});
export { careers_uniqueworkplace_label1 as "careers_uniqueWorkplace_label" }